import { render } from "./SmartfoldersFlickr.vue?vue&type=template&id=1d443364&scoped=true"
import script from "./SmartfoldersFlickr.vue?vue&type=script&lang=js"
export * from "./SmartfoldersFlickr.vue?vue&type=script&lang=js"

import "./SmartfoldersFlickr.vue?vue&type=style&index=0&id=1d443364&lang=scss&scoped=true"

import exportComponent from "/home/controlcenter/sourcecode/dubiverse/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d443364"]])

export default __exports__